import Controller from '../abstracts/Controller';
import 'scss-templates/t-listing.scss';

export default class ListingController extends Controller {
  static get COMPONENTS() {
    return [
      'ShortcutComponent',
      'FiltersComponent',
      'PriceRangeComponent',
      'SwitchComponent',
      'ListingHeadComponent',
      'CategoryFilterComponent',
      'SearchComponent',
      'PaginationComponent',
      'ActiveFiltersComponent',
      'RecommendationEngineComponent',
      'ListingEditorialComponent',
      'VisualMerchandisingComponent',
      'HistoryManagerComponent',
      'SaleRangeComponent',
      'SalesScrollbarComponent',
      'ListingCarouselComponent',
      'DropdownComponent',
      'TextualShortcutComponent',
      'ShortcutImageComponent',
      'HeroComponent',
    ];
  }

}
